// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"42ab5ba9","466":"c5b3758e","787":"f0ba9cbb"}[chunkId] + ".chunk.js";
};